/**
 * The entry point, and deliberately the smallest one in the repository.
 *
 * No router, no query client, no auth provider, no error boundary that reports
 * anywhere — the product's front ends need all four and this page needs none of
 * them. There is one piece of state on the whole site (the enquiry form's), and
 * it lives in the component that owns it.
 *
 * `StrictMode` stays on for the same reason it is on in `apps/web`: it surfaces
 * a double-invoked effect during development, and there is no reason for a page
 * this small to have one.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (container === null) throw new Error('index.html is missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
